import { writable } from 'svelte/store';
import buildValidator from './builder';

const createFieldValidator = (validators: Array<Validator>): any => {
  const { subscribe, set, update } = writable({ dirty: false, valid: false, message: null });
  const validator = buildValidator(validators);
  let inputElement = undefined;
  let hasFocus = false;

  const validate = (forceValidation = false) => {
    if (!inputElement) {
      return;
    }
    if (!forceValidation && !hasFocus) {
      return;
    }
    const result = validator(inputElement.value, true);
    set(result);
  };

  const setError = (message: string, valid: boolean): void => {
    update((state) => {
      state.message = message;
      state.valid = valid;
      return state;
    });
  };

  const action = (node: any) => {
    inputElement = node.querySelector('input');

    if (!inputElement) {
      throw new DOMException('Input element node found - Validator');
    }

    inputElement.addEventListener('focus', function () {
      hasFocus = true;
    });
    inputElement.addEventListener('blur', function () {
      validate();
      hasFocus = false;
    });

    return {
      update() {
        validate();
      },
    };
  };

  return [{ subscribe, validate, setError }, action];
};

export default createFieldValidator;
